import { Link } from "react-router-dom";

const STATS = [
  { value: "20,000+", label: "影视作品" },
  { value: "6 大地区", label: "内容覆盖" },
  { value: "1080P", label: "高清画质" },
  { value: "每日更新", label: "追剧无忧" },
];

export default function IntroSection() {
  return (
    <section className="overflow-hidden rounded-lg border border-background-200/80 bg-background-100">
      <div className="grid grid-cols-1 lg:grid-cols-2">
        <div className="p-8 md:p-12">
          <span className="text-xs font-medium uppercase tracking-[0.2em] text-primary-600">
            About Panda Cinema
          </span>
          <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            关于熊猫影院
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            熊猫影院是一个面向影视爱好者的在线影视内容平台。我们汇聚电影、电视剧等多种影视资源，
            提供快速搜索、多维筛选与清晰的作品详情，让你更轻松地找到想看的作品，也更高效地发现新的好剧。
          </p>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            我们希望用简洁明快的浏览体验和丰富的分类标签，让不同年龄层的观众都能在这里享受观影的乐趣。
          </p>
          <Link
            to="/about"
            className="mt-7 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
          >
            了解更多
            <i className="ri-arrow-right-line text-base"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 gap-px bg-background-200/70">
          {STATS.map((stat) => (
            <div
              key={stat.label}
              className="flex flex-col items-center justify-center bg-background-50 px-4 py-10 text-center"
            >
              <span className="font-heading text-2xl font-bold text-primary-600 md:text-3xl">
                {stat.value}
              </span>
              <span className="mt-2 text-xs text-foreground-500 md:text-sm">{stat.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}